import { DataElementRef } from './dataelementref.model';

export class NotRelevantDataElements {
  dataElementReferences: DataElementRef[];
}
